import React from "react"
import { useSelector } from "react-redux"

import { useTranslate } from "context/translateContext"
import openZendeskChat from "shared/services/zendesk/openZendeskChat"

import Button from "../Button/Button"

const ZendeskButton = () => {
  const { t: translate } = useTranslate()
  const language = useSelector(state => state.i18nState.lang)

  return (
    <Button
      variation="primary"
      size="medium"
      onClick={() => openZendeskChat(language)}
    >
      {translate("Need Help?")}
    </Button>
  )
}

export default ZendeskButton
